import React from 'react';
import { Link } from 'react-router-dom';
import './index.less';

export default () => (
  <div className="headerLogo-wrapper">
    <Link to="/">
      <img
        src={`${process.env.TARGET}static/logos/logo.png`}
        alt=""
        // style={{ width: 234, height: 80 }}
      />
    </Link>
  </div>
);
